export default function getWordPressLanguageReducer
    (state = { error:null, success:null, processing:false }, action) {

    switch (action.type)
    {
        case 'GET_WORD_PRESS_LANGUAGE_SUCCESS':
            return {...state, ...{success: action.success }};

        case 'GET_WORD_PRESS_LANGUAGE_ERROR':
            return {...state, ...{ error: action.error }};

        case 'GET_WORD_PRESS_LANGUAGE_PROCESSING':
            return {...state, ...{ processing: action.processing }};

        default: return state;
    }
}